/* Andy Cooks – recipe comments add-ons (works alongside assets/ac-reviews.js)
   1. "Email me when someone replies" tick box on the comment form and the reply forms. It sends notifyOnReply=true
      with the post, the same field the Recipes by Andy app uses, which triggers the "reply" email in Klaviyo.
   2. Replies from Andy (posted in the app as "Andy") show his photo in the round icon. */
(function () {
  'use strict';
  var root = document.querySelector('[data-acr-reviews]');
  if (!root || window.ACReviewsExtra) return;
  window.ACReviewsExtra = true;
  var acT = function (k, f) { return (window.AC_I18N && window.AC_I18N[k]) || f; };

  var css = document.createElement('style');
  css.textContent =
    '.acr-rev__notify{display:flex;align-items:flex-start;gap:10px;margin:2px 0 14px;font-size:15px;line-height:1.4;cursor:pointer;color:inherit}' +
    '.acr-rev__notify input{flex:none;width:18px;height:18px;margin:1px 0 0;accent-color:#ee7f33;cursor:pointer}';
  document.head.appendChild(css);

  function addNotify(form) {
    if (!form || form.querySelector('.acr-rev__notify')) return;
    var lab = document.createElement('label');
    lab.className = 'acr-rev__notify';
    var box = document.createElement('input');
    box.type = 'checkbox'; box.name = 'notifyOnReply'; box.value = 'true';
    lab.appendChild(box);
    lab.appendChild(document.createTextNode(acT('ac.js.reviews.notify_reply', 'Email me when someone replies to my comment')));
    var anchor = form.querySelector('[data-rev-ts], .acr-rev__ts, .acr-rev__actions, .acr-rev__submit');
    if (anchor) anchor.parentNode.insertBefore(lab, anchor); else form.appendChild(lab);
  }

  /* Andy's own replies (name "Andy", shown with the Andy Cooks badge): his photo instead of the letter */
  var me = document.currentScript;   /* assets/andy-avatar.jpg sits next to this file */
  var PHOTO = me && /ac-reviews-extra\.js/.test(me.src) ? me.src.replace(/ac-reviews-extra\.js.*$/, 'andy-avatar.jpg') : '';
  function andyName(scope) {
    [].forEach.call((scope || root).querySelectorAll('.acr-rev__item--reply'), function (it) {
      var n = it.querySelector('.acr-rev__name'), av = it.querySelector('.acr-rev__av');
      if (!PHOTO || !n || !av || av.dataset.andy || !it.querySelector('.acr-rev__badge') || !/^andy$/i.test((n.textContent || '').trim())) return;
      av.dataset.andy = '1';
      av.textContent = '';
      av.style.background = 'url(' + PHOTO + ') center / cover no-repeat #222';
    });
  }

  addNotify(root.querySelector('[data-rev-form]'));
  andyName();
  new MutationObserver(function (muts) {
    muts.forEach(function (m) {
      [].forEach.call(m.addedNodes, function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches('.acr-rev__rform')) addNotify(node);
        andyName(node.parentNode || root);
      });
    });
  }).observe(root, { childList: true, subtree: true });
})();
